const slider = new Swiper('.slider__swiper', {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    allowTouchMove: false,
    speed: 1000,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.slider__swiper-button-next',
        prevEl: '.slider__swiper-button-prev',
    },
});

const categoriesSlider = new Swiper('.tiles-categories__swiper', {
    slidesPerView: 2.07,
    spaceBetween: 16,
    breakpoints: {
        768: {
            slidesPerView: 3.1,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
});
